export default __webpack_public_path__ + "static/article-digital-financial-management-is-safer-than-cash-4ad7b523d7a6f4d4352e55cb657af889.jpg";